export default "__VITE_ASSET__Bqo_XN6t__"